<template>
  <div v-if="open" class="ins-modal" @click.self="$emit('close')">
    <div class="ins-modal-box" :style="maxWidthStyle">
      <button type="button" class="ins-modal-x" @click="$emit('close')" aria-label="Close">&times;</button>
      <h3 class="ins-modal-title">{{ title }}</h3>
      <div v-if="loading" class="ins-loading">Loading…</div>
      <template v-else>
        <div v-if="showToolbar" class="ins-drill-toolbar">
          <input
            v-if="searchable"
            type="text"
            class="ins-search ins-drill-search"
            :value="searchValue"
            :placeholder="searchPlaceholder"
            @input="$emit('update:searchValue', $event.target.value)"
          />
          <slot name="toolbar"></slot>
          <button v-if="exportable" type="button" class="ins-chip ins-csv-btn" @click="$emit('export')" title="Download these rows">⬇ {{ exportLabel }}</button>
        </div>
        <slot></slot>
      </template>
    </div>
  </div>
</template>

<script>
/* Shared drill-down modal shell for the Insights reports. Report owns the body (its own list/tree
 * markup) via the default slot; the shell owns the overlay, close (backdrop + × + Esc), the optional
 * search box (v-model:searchValue), and an optional export button (emits `export`) alongside a
 * #toolbar slot for extra filters/buttons. */
export default {
  name: "InsDrillModal",
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    searchable: { type: Boolean, default: false },
    searchValue: { type: String, default: "" },
    searchPlaceholder: { type: String, default: "Filter…" },
    exportable: { type: Boolean, default: false },
    exportLabel: { type: String, default: "CSV" },
    maxWidth: { type: Number, default: 860 },
  },
  computed: {
    showToolbar() { return this.searchable || this.exportable || !!this.$slots.toolbar; },
    maxWidthStyle() { return { maxWidth: this.maxWidth + "px" }; },
  },
  watch: {
    open(v) { if (v) document.addEventListener("keydown", this.onKey); else document.removeEventListener("keydown", this.onKey); },
  },
  beforeDestroy() { document.removeEventListener("keydown", this.onKey); },
  methods: {
    onKey(e) { if (e.key === "Escape") this.$emit("close"); },
  },
};
</script>

<style scoped>
.ins-modal { position: fixed; inset: 0; background: rgba(0,0,0,0.45); display: flex; align-items: center; justify-content: center; z-index: 1050; padding: 20px; }
.ins-modal-box { position: relative; background: var(--ins-card); border-radius: 10px; border-top: 3px solid var(--ins-accent); box-shadow: 0 10px 40px rgba(0,0,0,0.3); width: 100%; max-height: 82vh; overflow: auto; padding: 20px 22px 24px; }
.ins-modal-x { position: absolute; top: 10px; right: 14px; border: none; background: none; font-size: 26px; line-height: 1; color: var(--ins-text-mute); cursor: pointer; }
.ins-modal-title { font-size: 17px; font-weight: 700; color: var(--ins-text); margin: 0 0 14px; padding-right: 24px; }
.ins-loading { padding: 40px; text-align: center; color: var(--ins-text-mute); }
.ins-drill-toolbar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-bottom: 12px; }
.ins-drill-toolbar .ins-search { margin-bottom: 0; }
.ins-csv-btn:disabled { opacity: 0.5; cursor: default; }
</style>
